import { alpha } from '@mui/material';

export default {
  root: ({ isMobile, height, src }) => ({
    height: height || (isMobile ? 76 : 140),
    overflow: 'hidden',
    borderRadius: isMobile ? '10px' : '20px',
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    bgcolor: 'secondary.light',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  }),
  overlay: ({ palette }) => ({
    px: 2,
    top: 0,
    left: 0,
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    background: alpha(palette.background.default, 0.8),
    opacity: 0,
    transition: '0.3s',
    '&:hover': {
      opacity: 1,
    },
  }),
  title: {
    mb: 1,
    fontSize: 16,
    overflow: 'hidden',
    textAlign: 'center',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  gameImage: ({ src }) => ({
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    bgcolor: 'secondary.light',
  }),
};
